import type { SVGProps } from 'react';
const SvgStar06 = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 14.667v-3.333m0-6.667V1.334M1.333 3.001h3.333M1.333 13h3.333m4-11L7.51 5.007c-.188.488-.282.733-.428.938a2 2 0 0 1-.47.471c-.207.147-.45.24-.94.429L2.666 8l3.006 1.156c.49.188.733.282.94.428a2 2 0 0 1 .47.47c.146.207.24.45.428.94L8.666 14l1.156-3.006c.189-.49.283-.733.429-.94a2 2 0 0 1 .47-.47c.206-.146.45-.24.94-.428L14.665 8 11.66 6.845c-.488-.188-.733-.282-.938-.429a2 2 0 0 1-.471-.47c-.146-.206-.24-.45-.429-.94z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
    />
  </svg>
);
export default SvgStar06;
export { SvgStar06 };
